import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { adminAct, btnDark, btnLine } from "./shared";

const GROUPS = [
  ["members", "Jenova Girls (community members)"],
  ["founding", "Founding members"],
  ["customers", "Everyone who has placed an order"],
  ["newsletter", "Newsletter & restock sign-ups"],
];

export function AnnouncementEmail({ ann, onClose, onSent }) {
  const [groups, setGroups] = useState(["members"]);
  const [info, setInfo] = useState(null);
  const [net, setNet] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/admin/community/announcements/${ann.id}/email-preview`).then(({ data }) => setInfo(data)).catch(() => setInfo({ counts: {}, already_sent: 0 }));
  }, [ann.id]);
  useEffect(() => {
    setNet(null);
    api.post(`/admin/community/announcements/${ann.id}/email-preview`, { groups }).then(({ data }) => setNet(data.net)).catch(() => {});
  }, [ann.id, groups]);
  const toggle = (g) => setGroups((x) => (x.includes(g) ? x.filter((y) => y !== g) : [...x, g]));
  const send = async () => {
    if (!window.confirm(`Send this announcement to ${net} people now?`)) return;
    setBusy(true);
    const r = await adminAct(() => api.post(`/admin/community/announcements/${ann.id}/email`, { groups }));
    setBusy(false);
    if (r) onSent(r);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="ann-email-dialog">
        <DialogTitle className="font-serif text-2xl font-light">Email “{ann.title}”</DialogTitle>
        <div className="space-y-3">
          {GROUPS.map(([g, label]) => (
            <label key={g} className="flex items-center justify-between gap-3 text-sm border border-[#F0E8DD] rounded-lg px-4 py-3">
              <span className="flex items-center gap-3">
                <input type="checkbox" className="accent-[#2B2522]" checked={groups.includes(g)} onChange={() => toggle(g)} data-testid={`ann-email-group-${g}`} />
                {label}
              </span>
              <span className="text-xs text-[#7A6A62]" data-testid={`ann-email-count-${g}`}>{info ? info.counts[g] ?? 0 : "…"}</span>
            </label>
          ))}
        </div>
        <p className="text-xs text-[#7A6A62]" data-testid="ann-email-note">
          Each person gets it once, even if she's in several groups.{info?.already_sent ? ` ${info.already_sent} already received this one and will be skipped.` : ""} People who unsubscribed from bulletins are skipped.
          {ann.audience !== "public" && " Note: this announcement is not public, so non-members will be asked to sign in to read it."}
        </p>
        <div className="flex justify-end gap-2">
          <button className={btnLine} onClick={onClose}>Cancel</button>
          <button className={btnDark} disabled={busy || !groups.length || !net} onClick={send} data-testid="ann-email-send-btn">
            {busy ? "Sending…" : net == null ? "Counting…" : net ? `Send to ${net} people` : "Everyone selected already has it"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
